const config = {
    webUrl: "http://www.abipp.com",
    siteName: "ABIPP",
    siteSlogan: "",
    siteShortTitle: "ABIPP",
    siteLongTitle: "Akhand Bharat Industries Professional Party",
    siteKeywords: "ABIPP, Akhand Bharat Industries Professional Part, Indian indistries, Political Party",
    partyRegNos: "56/251/2023-24/PPP-I",
};

export default config;
